var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-contact-done"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$translate('ACTION_CONTACT_DONE_TITLE'))}}),_c('div',{staticClass:"body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }